module.exports = __webpack_public_path__ + "img/w3_delivery_dark.0afa2514.png";